export default __webpack_public_path__ + "static/media/bg.ad4360da.png";